/*
 * Shared reveal animation for every hs-shed-about-* section on the About
 * page. One shared file, loaded once, instead of a copy inlined per
 * section — inlining it per section caused a real bug: each section's
 * script guarded itself with the same `window.HSShedAboutAnimInit` flag,
 * so only the FIRST section's script ever ran (the rest returned early
 * before their own querySelectorAll had a chance to see their section's
 * elements, since later sections' HTML doesn't exist in the DOM yet when
 * an earlier section's inline <script> executes). Runs on
 * DOMContentLoaded instead, once the whole page (all sections) exists.
 */
(function () {
  if (window.HSShedAboutAnimInit) return;
  window.HSShedAboutAnimInit = true;

  function show(el) {
    el.classList.add('hs-shed-about--visible');
  }

  function revealOnLoad(el) {
    if (document.visibilityState === 'hidden') {
      show(el);
      return;
    }
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { show(el); });
    });
    setTimeout(function () { show(el); }, 100);
  }

  function revealOnScroll(el) {
    if (!('IntersectionObserver' in window) || document.visibilityState === 'hidden') {
      show(el);
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            show(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    io.observe(el);
    setTimeout(function () { show(el); }, 1500);
  }

  function init() {
    document.querySelectorAll('.js-hs-about-anim').forEach(revealOnLoad);
    document.querySelectorAll('.js-hs-about-anim-scroll').forEach(revealOnScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Fit-to-width shrink for .hs-shed-about-hero__title — added 2026-11-02,
  // same problem/solution already proven on .hs-shed-hero__title (see the
  // script comment in sections/hs-shed-text-hero.liquid): a long word
  // ("Contact") or a wide phrase ("HUNTING SEASON") can overflow a narrow
  // phone's width at this title's fixed-rem size, and with no space to
  // break at (or, for the 2-word line, a theme-wide break-word default
  // allowing a mid-word split) the browser wraps or breaks mid-word
  // instead. white-space: nowrap on the title line (component-hs-shed-
  // about-hero.css) stops the break; this measures each line's real
  // rendered width against its container and shrinks via
  // --hs-about-hero-fit only if it actually doesn't fit.
  function naturalAboutWidth(line, title) {
    var clone = line.cloneNode(true);
    var titleStyle = getComputedStyle(title);
    clone.style.position = 'absolute';
    clone.style.visibility = 'hidden';
    clone.style.display = 'inline-block';
    clone.style.whiteSpace = 'nowrap';
    clone.style.transform = 'none';
    clone.style.fontSize = titleStyle.fontSize;
    clone.style.fontFamily = titleStyle.fontFamily;
    clone.style.fontWeight = titleStyle.fontWeight;
    clone.style.fontStretch = titleStyle.fontStretch;
    clone.style.fontVariationSettings = titleStyle.fontVariationSettings;
    clone.style.letterSpacing = titleStyle.letterSpacing;
    clone.style.textTransform = titleStyle.textTransform;
    document.body.appendChild(clone);
    var width = clone.getBoundingClientRect().width;
    clone.remove();
    return width;
  }

  function fitAboutHero(title) {
    var lines = title.querySelectorAll('.hs-shed-about-hero__title-line');
    if (!lines.length) return;
    title.style.setProperty('--hs-about-hero-fit', 1);
    var available = title.getBoundingClientRect().width;
    if (!available) return;
    var widest = 0;
    lines.forEach(function (line) {
      widest = Math.max(widest, naturalAboutWidth(line, title));
    });
    if (widest > available) {
      var fit = (available / widest) * 0.98;
      title.style.setProperty('--hs-about-hero-fit', fit);
    }
  }

  function fitAllAboutHeroes() {
    document.querySelectorAll('.hs-shed-about-hero__title').forEach(fitAboutHero);
  }

  fitAllAboutHeroes();
  window.addEventListener('resize', fitAllAboutHeroes);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(fitAllAboutHeroes);
  }
  document.addEventListener('shopify:section:load', fitAllAboutHeroes);
})();
